import { ColumnDef } from "@tanstack/react-table";

import { MyLead } from "./schema";

import { DataTableColumnHeader } from "./data-table-column-header";

import { Badge } from "@/components/ui/badge/badge";
import { DataTableRowActions } from "./data-table-row-actions";
import { DataTableSearchableColumn } from "@/types/tables";
import { format } from "date-fns";
import { convertUTCtoISTWithMinus } from "@/utils";
import { Checkbox } from "@/components/ui/checkbox/checkbox";
import { LeadLatestComment } from "./lead-comments/lead-latest-comment";
// import { DataTableRowActions } from "./data-table-row-actions";

export function getColumns(): ColumnDef<MyLead>[] {
  return [
    {
      id: "select",
      header: ({ table }) => (
        <Checkbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() && "indeterminate")
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
          className="translate-y-[2px]"
        />
      ),
      cell: ({ row }) => (
        <Checkbox
          checked={row.getIsSelected()}
          onCheckedChange={(value) => row.toggleSelected(!!value)}
          aria-label="Select row"
          className="translate-y-[2px]"
        />
      ),
      enableSorting: false,
      enableHiding: false,
    },
    {
      accessorKey: "id",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Index" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2 flex-col">
            <span>{row.index + 1}</span>
            {row.original?.allotedAt && (
              <div className="flex items-center gap-2 text-[12px]">
                ( Alloted At -{" "}
                {format(
                  convertUTCtoISTWithMinus(row.original.allotedAt),
                  "PPpp"
                )}{" "}
                )
              </div>
            )}
          </div>
        );
      },
      enableSorting: false,
    },
    {
      accessorKey: "mname",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Name" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("mname")}
            </span>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        let search = typeof value === "string" ? value : value?.[0];
        const rowValue = row.getValue(id) as string;

        return rowValue?.toLowerCase()?.includes(search?.toLowerCase());

        // return Boolean(
        //   row.getValue(id) === null ||
        //     (row.getValue(id) as string)?.toString() === null ||
        //     (row.getValue(id) as string)?.toLowerCase() === null
        //     ? void 0
        //     : (row.getValue(id) as string)?.includes(search)
        // );
      },
    },

    {
      accessorKey: "broker",
      header: ({ column }) => {
        return <DataTableColumnHeader column={column} title="Broker" />;
      },
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("broker")}
            </span>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    },

    {
      accessorKey: "phone",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Phone" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <span className="max-w-[500px] truncate font-medium">
              {row.getValue("phone")}
            </span>
          </div>
        );
      },
    },

    {
      accessorKey: "originalStatus",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Lead Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("originalStatus")}</Badge>
          </div>
        );
      },
    },

    {
      accessorKey: "status",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Calling Sub Status" />
      ),
      cell: ({ row }) => {
        return (
          <div className="flex space-x-2">
            <Badge>{row.getValue("status")}</Badge>
          </div>
        );
      },
      filterFn: (row, id, value) => {
        return value.includes(row.getValue(id));
      },
    },

    {
      id: "lead-comments",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Comment" />
      ),
      cell: ({ row }) => <LeadLatestComment row={row} />,
    },
    {
      id: "actions",
      cell: ({ row }) => <DataTableRowActions row={row} />,
    },
  ];
}

export const searchableColumns: DataTableSearchableColumn<MyLead>[] = [
  {
    id: "mname",
    placeholder: "Filter name...",
  },
];
